import { DefaultOrderHint } from "@ms/uno-constants/lib/local/OrderHintConstants";
/**
 * Normalize the order hint to ensure it's never undefined or null or empty.
 * @param orderHint The order hint to normalize
 */ export function normalizeOrderHint(orderHint) {
    const trimmed = orderHint?.trim();
    if (!trimmed) {
        return DefaultOrderHint;
    } else {
        // Do not modify the original value unless it trims to empty
        return orderHint;
    }
}
